import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter-list",
  "use": "filter-list-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"filter-list\"><path d=\"M20 36h8v-4h-8v4zM6 12v4h36v-4H6zm6 14h24v-4H12v4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol